import { Component } from '@angular/core';
import { ThreeButtonDialog } from '../../../features/models/three-button-dialog.model';
import { ThreeButtonDialogService } from '../../../features/services/three.button.dialog.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
      selector: 'app-three-button-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule
  ],
  templateUrl: './three-button-dialog.component.html',
  styleUrls: ['./three-button-dialog.component.css']
})
export class ThreeButtonDialogComponent {

    visible = false;

    dialog!: ThreeButtonDialog;

    constructor(private dialogService: ThreeButtonDialogService) {

        this.dialogService.dialogRequested.subscribe(d => {

            this.dialog = d;

            this.visible = true;

        });

    }

    click(result: string) {

        this.visible = false;

        this.dialogService.close(result);

    }

}